var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import CustomerService from "../services/CustomerService";
import Notification from "../../App/components/Notification";
import Modal from 'react-bootstrap/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { onEnterOrSpace } from "../../App/utils/accessibility";
function ModalEmailIntegration(props) {
    var _a = useState(props.email), hubEmail = _a[0], setHubEmail = _a[1];
    function createIntegration() {
        Notification().Loading.dots("Carregando...");
        var email = hubEmail.trim();
        var isUsingCurrentEmail = email === "" || email === props.email;
        var request;
        if (isUsingCurrentEmail) {
            request = CustomerService.createIntegration(props.customerId);
        }
        else {
            request = CustomerService.createIntegration(props.customerId, email);
        }
        request.then(function (res) {
            Notification().Notify.success(res.data.success);
            props.closeModal();
            props.fetchHubs();
            props.setIsButtonDisabled(true);
            props.providerData(props.customerId.toString());
        }).catch(function (err) {
            if (err.response && err.response.data) {
                var error = err.response.data;
                if (error.error) {
                    Notification().Notify.failure(error.error);
                }
            }
            else {
                Notification().Notify.failure("Erro!");
            }
        }).finally(function () {
            Notification().Loading.remove();
        });
    }
    ;
    function handleInputChange(event) {
        setHubEmail(event.target.value);
    }
    ;
    return (_jsxs(Modal, __assign({ show: props.show, onHide: props.closeModal, "aria-labelledby": "contained-modal-title-vcenter", centered: true, className: "default-modal-styling" }, { children: [_jsxs(Modal.Header, __assign({ style: { paddingLeft: "0.9rem" } }, { children: [_jsx(Modal.Title, { children: "Deseja utilizar e-mail existente?" }), _jsx(CloseIcon, { className: "modal-confirm-email-close-icon", id: "btn-modal-email-integration-close-icon", role: "button", tabIndex: 0, "aria-label": "Fechar", onClick: props.closeModal, onKeyDown: onEnterOrSpace(props.closeModal) })] })), _jsxs(Modal.Body, __assign({ className: "d-flex flex-column " }, { children: [_jsx("p", __assign({ className: "mb-0" }, { children: "Voc\u00EA deseja utilizar o mesmo e-mail j\u00E1 existente para a integra\u00E7\u00E3o?" })), _jsxs("p", { children: ["Se voc\u00EA n\u00E3o preencher ou editar o campo abaixo, ser\u00E1 utilizado o ", _jsx("strong", { children: "e-mail atual" }), "."] }), _jsx("input", { type: "text", value: hubEmail, onChange: handleInputChange, className: "input-email-integration", placeholder: "Digite o e-mail" })] })), _jsxs(Modal.Footer, { children: [_jsx("button", __assign({ id: "btn-modal-email-integration-close", onClick: props.closeModal, className: "button-with-blue-border", style: { width: "110px", height: "42px" } }, { children: "Fechar" })), _jsx("button", __assign({ id: "btn-modal-email-integration-confirm", onClick: createIntegration, className: "blue-button", style: { width: "150px", height: "42px" } }, { children: "Liberar integra\u00E7\u00E3o" }))] })] })));
}
export default ModalEmailIntegration;
